import MUIButton, { ButtonProps as MUIButtonProps } from "@material-ui/core/Button";
import React, { FC } from "react";
import { styled } from "@material-ui/styles";

import Loader from "../Loader";

type ButtonProps = {
  isLoading?: boolean;
  loaderSize?: number;
  loaderColor?: string;
};

const BaseButton = styled(MUIButton)<MUIButtonProps>(({ variant }) => ({
  borderRadius: 4,
  fontSize: 20,
  fontWeight: 700,
  height: 40,
  minWidth: 156,
  backgroundColor: variant === "outlined" ? "inherit" : "#FF7262",
  textTransform: "none",
  color: variant === "outlined" ? "#FF7262" : "#fff",
  borderColor: "#FF7262",
  "&:hover": {
    backgroundColor: variant === "outlined" ? "#FF7262" : "#EB6246",
    color: "#fff",
  },
}));

const Button: FC<MUIButtonProps & ButtonProps> = ({
  children,
  isLoading,
  loaderSize,
  disabled,
  loaderColor,
  ...rest
}) => {
  return (
    <BaseButton disableElevation {...rest} disabled={isLoading || disabled}>
      {isLoading ? (
        <Loader
          isAbsolutePosition={false}
          size={loaderSize ?? 40}
          style={{
            color: loaderColor || "#fff",
          }}
        />
      ) : (
        children
      )}
    </BaseButton>
  );
};

export default Button;
